<div mat-dialog-content>
    <div class="mat-dialog-content">
        <div class="head-type-modal-list">
            <img src="assets/images/alert.png" />
            <h2>Paciente não encontrado!</h2>
        </div>

        <div *ngIf="!data.imageResultRef" class="body-confirm-modal-list">
            <span>Você ainda não possui cadastro.</span>
            <span class="row">Verifique seu CPF ou continue sem identificação.</span>
        </div>
        <div *ngIf="data.imageResultRef" class="body-confirm-modal-list">
            Não foi possível identificar seu cadastro, tente novamente ou continue sem identificação.
        </div>

        <div class="footer-confirm-modal-list">
            <button *ngIf="data.imageResultRef" mat-flat-button color="primary" class="btn-block"
                (click)="tryAgain()">Tentar Novamente</button>
            <button *ngIf="data.imageResultRef" mat-flat-button color="accent" class="btn-block"
                (click)="close()">Cancelar</button>
            <button *ngIf="!data.imageResultRef" mat-flat-button color="primary" class="btn-block"
                (click)="close()">Fechar</button>
        </div>
    </div>
</div>